import { translate } from '@/mixins/translate';
const { $$t } = translate('_web_tournaments_double-eliminations').methods; // do not use as mixin

export default {
  methods: {
    roundName(rounds, index) {
      const _$t = $$t.bind(this);
      const { length } = rounds;
      const isUpper = !!rounds[0].matches; // lower grid has not matches in first round
      const hasGrandFinal = length % 2;
      return hasGrandFinal && index === length - 1
        ? _$t('Grand Final', 'grand_final')
        : index === length - 1 - hasGrandFinal
        ? _$t('Final')
        : index ===
          (isUpper ? length - 3 - hasGrandFinal : length - 2 - hasGrandFinal)
        ? isUpper
          ? _$t('Winners final', 'winners-final')
          : _$t('Losers final', 'losers-final')
        : isUpper
        ? _$t('Upper Round {num}', 'upper-round', {
            num: index < 2 ? index + 1 : (index + 3) / 2,
          })
        : _$t('Lower Round {num}', 'lower-round', { num: index });
    },
    roundNameTable(rounds, index, { grid, grid_index: gridIndex } = {}) {
      const $t = $$t.bind(this);

      if (grid === 'lower') {
        return $t('Lower Round {num}', 'lower-round', { num: gridIndex + 1 });
      }

      const { length } = rounds;
      const { length: upperRoundsLength } = rounds.filter(
        ({ grid } = {}) => grid === 'upper'
      );
      const hasGrandFinal = ((3 * upperRoundsLength - length) / 2) % 2; // why? - ask @olsy

      return hasGrandFinal && gridIndex === upperRoundsLength - 1
        ? $t('Grand Final', 'grand_final')
        : gridIndex === upperRoundsLength - 1 - hasGrandFinal
        ? $t('Final')
        : $t('Upper Round {num}', 'upper-round', { num: gridIndex + 1 });
    },
  },
};
